import React from 'react';

const features = [
  { 
    title: 'Create Invoices in seconds', 
    desc: 'Generate professional invoices in seconds with customizable templates.',
    icon: '📄'
  },
  { 
    title: 'Track Payments', 
    desc: 'Monitor invoice status and track payment status.',
    icon: '💰'
  },
   { 
    title: 'Alter pricing and tax rates on the go', 
    desc: 'Easily adjust pricing and tax rates directly on your invoices.',
    icon: '📄'
  },
    { 
    title: 'Detailed Reports & Analytics', 
    desc: 'Gain insights with comprehensive reports and analytics.',
    icon: '📊'
  },
  { 
    title: 'Manage Clients & Products', 
    desc: 'Organize client information and maintain your product catalog.',
    icon: '👥'
  },
  { 
    title: 'Multi-Currency & Tax', 
    desc: 'Handle different currencies and tax rates with ease.',
    icon: '🌍'
  },
  { 
    title: 'User Roles & Permissions', 
    desc: 'Control access with granular admin and user roles.',
    icon: '🔐'
  },
  { 
    title: 'Cloud Storage', 
    desc: 'Secure cloud storage for all your invoices and documents.',
    icon: '☁️'
  },
   { 
    title: 'Transaction Pricing', 
    desc: 'Flexible transaction-based pricing to suit your business needs.',
    icon: '💳'
  },
];

export default function Home() {
  return (
    <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 24px' }}>
      <section style={{ textAlign: 'center', marginBottom: '64px' }}>
        <h1 style={{ fontSize: '48px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
          Invoice Management Made Simple
        </h1>
        <p style={{ fontSize: '20px', color: '#6b7280', marginBottom: '32px' }}>
          Simple and efficient invoicing for small businesses.
         Streamline your invoicing workflow and grow your business faster.
        </p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginTop: '32px' }}>
          <a className="btn btn-primary" href="#/register" style={{ padding: '12px 32px', fontSize: '18px', borderRadius: '8px', textDecoration: 'none', background: '#2563eb', color: '#fff' }}>Start Free Trial</a>
          <a className="btn" href="#/login" style={{ padding: '12px 32px', fontSize: '18px', borderRadius: '8px', textDecoration: 'none', border: '1px solid #d1d5db', color: '#374151', background: '#fff' }}>Login</a>
        </div>
      </section>

      <section className="features" style={{ marginTop: '64px' }}>
        <h2 style={{ textAlign: 'center', fontSize: '36px', fontWeight: '700', color: '#1f2937', marginBottom: '48px' }}>Features</h2>

        <div className="feature-grid" style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(3, 1fr)', 
          gap: '24px',
          marginBottom: '64px'
        }}>
          {features.map((f, i) => (
            <div key={i} style={{ 
              background: '#fff', 
              border: '1px solid #e5e7eb', 
              borderRadius: '12px', 
              padding: '32px 24px',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 1px 3px 0 rgba(0, 0, 0, 0.1)';
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>{f.icon}</div>
              <h4 style={{ fontSize: '20px', fontWeight: '600', color: '#1f2937', marginBottom: '12px' }}>{f.title}</h4>
              <p style={{ color: '#6b7280', fontSize: '16px', lineHeight: '1.6', margin: 0 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="cta" style={{ marginTop: '64px', textAlign: 'center', padding: '48px 24px', background: '#f9fafb', borderRadius: '16px' }}>
        <h3 style={{ fontSize: '32px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>Ready to get started?</h3>
        <p style={{ fontSize: '18px', color: '#6b7280', marginBottom: '32px' }}>Try a free trial — no credit card required.</p>
        <a className="btn btn-primary" href="#/register" style={{ padding: '12px 32px', fontSize: '18px', borderRadius: '8px', textDecoration: 'none', background: '#2563eb', color: '#fff' }}>Start Free Trial</a>
      </section>
    </div>
  );
}
